import { isIe } from '../utils/is-ms';

if (isIe()) {
	$('body').addClass('is-ie');
}
